import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { useDispatch } from 'react-redux';
import { Typography, Card, Divider } from '@mui/material';

import Button from 'components/Common/Button';
import Modal from 'components/Common/Modal';
import { AppDispatch } from 'redux/store';
import { createStaff } from 'redux/slices/staff/staffSlice';
import routes from 'constants/routes';
import CreateStaffForm from 'components/Staff/CreateStaffForm';
import { CreateStaff } from 'types/staff';
import CardWrapper from 'components/Common/CardWrapper';

export default function CreateNewStaff() {
    const dispatch = useDispatch<AppDispatch>();
    const navigate = useNavigate();
    const [modalOpen, setModalOpen] = useState(false);
    const [loading, setLoading] = useState(false);

    const handleSendInvitation = async (formValues: CreateStaff) => {
        try {
            setLoading(true);
            const res: any = await dispatch(createStaff({ formValues: { ...formValues, employeeType: 'CLERK' } }));
            setLoading(false);
            if (res?.payload?.code === 200) {
                setModalOpen(true);
            }
        } catch (error) {
            setLoading(false);
            throw error;
        }
    };
    const handleInvitationSuccess = () => {
        setModalOpen(false);
        navigate(routes.staff.main);
    };
    return (
        <CardWrapper>
            <Typography
                sx={{ fontSize: { xs: 16, sm: 24 }, mb: 2, width: { xs: '80%', sm: '50%' }, color: '#220E40', fontWeight: 400 }}
                variant="h1"
            >
                Create new employee
            </Typography>
            <Divider sx={{ borderBottomWidth: 2 }} />
            <Typography sx={{ mt: 2, mb: 4, fontSize: 14 }} variant="body1">
                Please fill in the information for the new employee below. Once you have provided the necessary information we will send an
                invitation to their email. They can then create an account and gain access to this portal based on the employee role you
                assign them.
            </Typography>
            <CreateStaffForm onSubmit={handleSendInvitation} loading={loading} />
            <Modal onClose={() => setModalOpen(false)} isOpen={modalOpen}>
                <>
                    <Typography sx={{ fontSize: 18, my: 2 }}>
                        An invitation email has been sent to the email listed for this employee.{' '}
                    </Typography>
                    <div style={{ display: 'flex', flexDirection: 'row', justifyContent: 'space-around', marginTop: 32 }}>
                        <Button onClick={handleInvitationSuccess} width={152} title="Done" />
                    </div>
                </>
            </Modal>
        </CardWrapper>
    );
}
